import {Component, inject} from '@angular/core';
import {LocaleService} from "../../../../locale/locale.service";
import {AdditionalActionHeaderComponent} from "../additional-action-header/additional-action-header.component";
import {RouterLink} from "@angular/router";
import {FooterComponent} from "../../../common/footer/footer.component";

@Component({
  selector: 'app-what-to-do',
  imports: [
    AdditionalActionHeaderComponent,
    RouterLink,
    FooterComponent
  ],
  templateUrl: './what-to-do.component.html',
  styleUrl: './what-to-do.component.css'
})
export class WhatToDoComponent {
  locale = inject(LocaleService);
}
